import { BrowserRouter, Routes, Route } from "react-router";

import { useEffect } from "react";
// import { createClient } from "@supabase/supabase-js";

import LandingPage from "@/LandingPage";
import TermsPage from "@/TermsPage";
import PrivacyPage from "@/PrivacyPage";
import CookiesPage from "@/CookiesPage";
import Plausible from "plausible-tracker";
import LearnMore from "./LearnMore";
import RegisterBeta from "./RegisterBeta";
import ContactUs from "./ContactUs";

function App() {
  useEffect(() => {
    const plausible = Plausible({
      domain: "aptfleet.com",
      trackLocalhost: true,
    });
    plausible.enableAutoPageviews();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/learn-more" element={<LearnMore />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/beta-register" element={<RegisterBeta/>} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
